<template>
	<div class="wrapperddiv">
	<!-- 卡片试图区域 -->
	<el-card class="box-card">
		<div slot="header" class="clearfix">
		  <span>用户管理</span>
		</div>
	  <!-- 搜索与添加区域 -->
		<el-row :gutter="20" style="margin-bottom: 30px;">
			<el-col :span="8">
				<el-input
				placeholder="请输入内容"
				v-model="queryInfo.query"
				clearable
				@input="changeValue"
				>
				    <el-button
					slot="append"
					icon="el-icon-search"
					@click="getUserList"
					></el-button>
				  </el-input>
				</el-col>
				<el-col :span="4">
					<el-button type="primary" @click="adduserData" v-Dclrights="71">添加用户</el-button>
					</el-col>
		</el-row>
		<!-- 用户列表区域 -->
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
		    <el-tab-pane label="全部用户" name="first"></el-tab-pane>
			<el-tab-pane label="公司内部用户" name="t0"></el-tab-pane>
			<el-tab-pane label="T1用户" name="t1"></el-tab-pane>
			<el-tab-pane label="T2用户" name="t2"></el-tab-pane>
		    <el-tab-pane name="second">
				 <span slot="label">
					 待审核注册用户
				<el-badge :value='this.dshs' :max="9999"></el-badge>
				</span>
			</el-tab-pane>
			<el-tab-pane name="third">
				<span slot="label">
					 未通过审核注册用户
				<el-badge :value='this.wtgshs' :max="9999"></el-badge>
				</span>
			</el-tab-pane>
			<el-tab-pane  name="xgzl">
				<span slot="label">
					待审核修改资料信息用户
				<el-badge :value='this.dshzczl' :max="9999"></el-badge>
				</span>
			</el-tab-pane>
			<!-- <el-tab-pane label="未分配等级用户" name="tnone"></el-tab-pane> -->
		 
		  </el-tabs>
		<!-- row-key能解决一下小bug -->
		 <el-table
		       row-key="id"
		      :data="userlist"
			  border
			  stripe
			  :header-cell-style="{ textAlign: 'center','background':'#E9E9E9','color':'#000000' }"
			  >
			  <el-table-column
			    type="index"
				fixed="left"
			   >
			  </el-table-column>
		      <el-table-column
		        prop="username"
		        label="用户名"
			    width="100px"
				fixed="left"
				>
		      </el-table-column>
      <!--    <el-table-column
              prop="nickname"
              label="昵称"
            width="150px"
          >
            </el-table-column> -->
			   <el-table-column
			     prop="rolename"
			     label="角色"
			   	width="120px"
			   		>
			   </el-table-column>
		      <el-table-column
		        prop="email"
		        label="邮箱"
				width="160px"
				>
		      </el-table-column>
			  <el-table-column
			    prop="phone"
			    label="手机号码"
				width="100px"
				>
			  </el-table-column>
			  <el-table-column
			    prop="businessaddress"
			    label="公司地址"
			  	width="200px"
			  				>
			  </el-table-column>
			  <el-table-column
			    prop="company"
			    label="公司名称"
			  	width="200px"
				fixed="left"
			  				>
			  </el-table-column>
			  <el-table-column
			    prop="iaecountries"
			    label="进出口国家"
			  	width="200px"
			  				>
			  </el-table-column>
			  <el-table-column
			    prop="xs_username"
			    label="专属销售"
			  	width="100px"
			   >
			  </el-table-column>
			  <el-table-column
			    prop="kf_username"
			    label="专属客服"
			  	width="100px"
			   >
			  </el-table-column>
			<el-table-column
			  prop="reg_method"
			  label="注册来源"
				width="120px"
			 >
			</el-table-column>
			  <el-table-column
			  	sortable
			  width="135px"
			    prop="create_time"
			    label="创建时间">
          <template slot-scope="scope">
          {{scope.row.create_time | fmtdate}}
          </template>
			  </el-table-column>
			  <el-table-column
			  	sortable
			  width="145px"
			    prop="lastlogin_time"
			    label="最后一次登录时间">
          <template slot-scope="scope">
          {{scope.row.lastlogin_time | fmtdate}}
          </template>
			  </el-table-column>
			  <el-table-column
			    label="状态"
				width="80px"
				prop="statesw"
				
				>
				<!-- 重点！！！！如果是字符串形式返回不加冒号active-value="1" inactive-value="2"；如果是数字类型返回的加冒号:active-value="1" :inactive-value="2"-->
				<template slot-scope="scope">
					<el-switch
					v-Dclrights="86"
				      v-model="scope.row.statesw"
					  @change="userStateChanged(scope.row)"
					  active-color="#13ce66"
					  inactive-color="#ff4949"
					  active-value="1"
					  inactive-value="2"
					 >
					</el-switch>
				</template>
			  </el-table-column>
			  <el-table-column
			  fixed="right"
			    prop="audit"
			    label="审核结果"
			  	width="110px"
				sortable
			   >
			   <template slot-scope="scope">
          <el-button  type="success" :key="2"  v-if="scope.row.audit == 2">已通过</el-button>
          		
          	   <el-button type="danger"  v-if="scope.row.audit == 3">未通过</el-button>
          	
          	   <el-button  type="warning" v-if="scope.row.audit == 1">待审核</el-button>
			   </template>
			     </el-table-column>
			   <el-table-column
			     prop="customer_rating"
			     label="客户等级"
			   	width="100px"
				fixed="right"
				sortable
			    >
				<template slot-scope="scope">
				<el-tag type="success" v-if="scope.row.customer_rating == 1">T0</el-tag>
				<el-tag type="danger" v-if="scope.row.customer_rating == 2">T1</el-tag>
				<el-tag type="info" v-if="scope.row.customer_rating == 3">T2</el-tag>
				</template>
			  </el-table-column>
			  <el-table-column
			  v-if='this.judgmentmenusList == true'
			  fixed="right"
			    label="操作"
				width="280px"
				>
				<template slot-scope="scope">
					<div>
						<el-tooltip effect="dark" content="审核" placement="top" :enterable="false" v-Dclrights="73" v-if="scope.row.audit !== 2">
						 	<el-button type="warning" icon="el-icon-coordinate" size="mini" @click="showEditDialog(scope.row)"></el-button>
						   </el-tooltip>
					<el-tooltip effect="dark" content="编辑" placement="top" :enterable="false" v-Dclrights="73" v-else>
					 	<el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)" ></el-button>
					   </el-tooltip>
					   <el-tooltip effect="dark" content="审核修改资料" placement="top" :enterable="false" v-Dclrights="90">
					    	<el-button type="info" icon="el-icon-view" size="mini" @click="showEditShzlDialog(scope.row)" ></el-button>
					      </el-tooltip>
					<el-tooltip effect="dark" content="删除" placement="top" :enterable="false" v-Dclrights="72">
					 	<el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row.id)" ></el-button>
					   </el-tooltip>
             <el-tooltip effect="dark" content="分配视图" placement="top" :enterable="false" v-Dclrights="75" v-if="scope.row.rid == 1 || scope.row.rid == 13 || scope.row.rid == 12 || scope.row.rid == 27">
               	<el-button  icon="el-icon-video-play" size="mini" @click="setView(scope.$index,scope.row)"></el-button>
              </el-tooltip>
			  
			  
			  
			  
			 <el-tooltip effect="dark" content="离职交接" placement="top" :enterable="false" v-Dclrights="96" v-if="scope.row.rid == 13 || scope.row.rid == 12 || scope.row.rid == 27" >
			    	<el-button type='success' icon="el-icon-document-copy" size="mini" @click="handOverClick(scope.$index,scope.row)"></el-button>
			   </el-tooltip>
			  
			  
			  
			  
			  
			  
			  
			  
			  </div>
					</template>
			  </el-table-column>
		    </el-table>
		<!-- 分页区域 -->
		<el-pagination
		background
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="queryInfo.pagenum"
		      :page-sizes="[20,50,100,200]"
		      :page-size="queryInfo.pagesize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>
	</el-card>
	<!-- 添加用户的对话框 -->
	<el-dialog
	  title="添加用户"
	  :visible.sync="addDialogVisible"
	  width="70%"
	  @close="addDialogClosed"
    :close-on-click-modal="false"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="addFormRules"
	 ref="addFormRef"
	 :model="addForm"
	 label-width="100px">
	 <el-form-item label="邮箱" prop="email">
	   <el-input v-model="addForm.email"></el-input>
	 </el-form-item>
	 <el-form-item label="密码" prop="password">
	   <el-input v-model="addForm.password" type="password"  show-password></el-input>
	 </el-form-item>
	   <el-form-item label="用户名" prop="username">
	     <el-input v-model="addForm.username"></el-input>
	   </el-form-item>
	<el-form-item label="手机号码" prop="phone">
	  <el-input v-model="addForm.phone"></el-input>
	</el-form-item>
	<el-form-item label="公司地址" prop="businessaddress">
	  <el-input v-model="addForm.businessaddress"></el-input>
	</el-form-item>
	  <el-form-item label="公司名称" prop="company">
	    <el-input v-model="addForm.company" @change="ssgsChange"></el-input>
	  </el-form-item>
	 <!-- <el-form-item label="进出口国家" prop="iaecountries">
	    <el-input
	      v-model="addForm.iaecountries"
	    ></el-input>
	  </el-form-item> -->
	  <el-form-item prop="sales" label="专属销售">
	  	<el-select
	  	v-model="addForm.sales" 
	  	filterable 
	  >
	  	    <el-option
	  	      v-for="item in salesList"
	  	      :key="item.sale_id"
	  	      :label="item.sale_username"
	  	      :value="item.sale_id">
	  	    </el-option>
	  	  </el-select>
	  </el-form-item>
	  <el-form-item prop="customer" label="专属客服">
	  	<el-select
	  	v-model="addForm.customer" 
	  	filterable 
	  >
	  	    <el-option
	  	      v-for="item in customerList"
	  	      :key="item.kf_id"
	  	      :label="item.kf_username"
	  	      :value="item.kf_id">
	  	    </el-option>
	  	  </el-select>
	  </el-form-item>	
	  <el-form-item prop="role" label="选择角色">
	  	<el-select
	  	v-model="addForm.role" 
	  	filterable 
	  >
	  	    <el-option
	  	      v-for="item in roleslist"
	  	      :key="item.rid"
	  	      :label="item.rolename"
	  	      :value="item.rid">
	  	    </el-option>
	  	  </el-select>
	  </el-form-item>
	<el-form-item prop="customer_rating" label="选择等级">
		<el-select
		v-model="addForm.customer_rating" 
		filterable 
	>
		    <el-option
		      v-for="item in levelList"
		      :key="item.value"
		      :label="item.label"
		      :value="item.value">
		    </el-option>
		  </el-select>
	</el-form-item>
	 <el-divider></el-divider>
	<el-form-item label="座机号码" prop="landline">
	  <el-input v-model="addForm.landline"></el-input>
	</el-form-item>
	<el-form-item label="QQ号码" prop="qq">
	  <el-input v-model="addForm.qq"></el-input>
	</el-form-item>
	
<!-- 	<el-form-item label="二维码名片" prop="wx_code"> -->
	<!-- 一定要加name属性 -->
	<!-- <el-upload
	  accept=".JPG, .PNG, .JPEG,.jpg, .png, .jpeg"
	  :limit="1"
	  list-type="picture-card"
	  action="http://127.0.0.1:3007/my/update/wxcodecard/"
	  :on-preview="handlePictureCardPreview"
	  :on-remove="handleRemove"
	  :on-success="handleSuccess"
	  :headers="headers"
	   name="wx_code"
	  >
	  <i class="el-icon-plus"></i>
	</el-upload>
	<el-dialog :visible.sync="dialogVisible">
	  <img width="100%" :src="dialogImageUrl" alt="">
	</el-dialog>
	</el-form-item> -->
	
	
	
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="addDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="addUser">确 定</el-button>
	  </span>
	</el-dialog>
	<!-- 修改用户的对话框 -->
	<el-dialog
	   :title="this.zcsh ==2 ? '编辑用户' :'审核用户注册'"
	  :visible.sync="editDialogVisible"
	  width="70%"
	  @close="editDialogClosed"
    :close-on-click-modal="false"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="editFormRules"
	 ref="editFormRef"
	 :model="editForm"
	 label-width="100px">
	 <el-form-item label="用户邮箱" prop="email">
	   <el-input v-model="editForm.email" disabled></el-input>
	 </el-form-item>
	   <el-form-item label="用户姓名" prop="username">
	     <el-input v-model="editForm.username"></el-input>
	   </el-form-item>
	 <el-form-item label="手机号码" prop="phone">
	   <el-input v-model="editForm.phone"></el-input>
	 </el-form-item>
	 <el-form-item label="公司地址" prop="businessaddress">
	   <el-input v-model="editForm.businessaddress"></el-input>
	 </el-form-item>
	   <el-form-item label="公司名称" prop="company">
	     <el-input v-model="editForm.company"></el-input>
	   </el-form-item>
	 <!--  <el-form-item label="进出口国家" prop="iaecountries">
	     <el-input
	       v-model="editForm.iaecountries"
	     ></el-input>
	   </el-form-item> -->
	   <el-form-item prop="sales_id" label="专属销售">
	   	<el-select
	   	v-model="editForm.sales_id" 
	   	filterable 
	   >
	   	    <el-option
	   	     v-for="item in salesList"
	   	     :key="item.sale_id"
	   	     :label="item.sale_username"
	   	     :value="item.sale_id">
	   	    </el-option>
	   	  </el-select>
	   </el-form-item>
	   <el-form-item prop="customer_id" label="专属客服">
	   	<el-select
	   	v-model="editForm.customer_id" 
	   	filterable 
	   >
	   	    <el-option
	   	      v-for="item in customerList"
	   	      :key="item.kf_id"
	   	      :label="item.kf_username"
	   	      :value="item.kf_id">
	   	    </el-option>
	   	  </el-select>
	   </el-form-item>	
	   <el-form-item
		v-if='zcsh ==2'
		prop="rid" label="选择角色">
	   	<el-select
	   	v-model="editForm.rid" 
	   	filterable 
	   >	
			<el-option
			  v-for="item in roleslist"
			  :key="item.rid"
			  :label="item.rolename"
			  :value="item.rid">
			</el-option>
			
			
	   	  </el-select>
	   </el-form-item>
	   
	   <el-form-item
	   		v-else
	   		prop="rid" label="选择角色">
	   	<el-select
	   	v-model="editForm.rid" 
	   	filterable 
	   >	
	   			<el-option
	   			  v-for="item in roleslist.filter(item =>item.rolename == '直客' || item.rolename == '同行客户' || item.rolename == '海外代理')"
	   			  :key="item.rid"
	   			  :label="item.rolename"
	   			  :value="item.rid">
	   			</el-option>
	   			
	   			
	   	  </el-select>
	   </el-form-item>
	   
	   
	   
	   
	   
	   
	   
	   
	   <el-form-item prop="customer_rating" label="选择等级">
	   	<el-select
	   	v-model="editForm.customer_rating" 
	   	filterable 
	   >
	   	    <el-option
	   	      v-for="item in levelList"
	   	      :key="item.value"
	   	      :label="item.label"
	   	      :value="item.value">
	   	    </el-option>
	   	  </el-select>
	   </el-form-item>
	     <div v-if="this.editForm.company == '上海中烜国际物流有限公司'">
	   <el-divider></el-divider>
	   <el-form-item label="座机号码" prop="landline">
	     <el-input v-model="editForm.landline"></el-input>
	   </el-form-item>
	   <el-form-item label="QQ号码" prop="qq">
	     <el-input v-model="editForm.qq"></el-input>
	   </el-form-item>
	   
	   
	   <el-form-item label="二维码名片" prop="wx_code">
	   <!-- 一定要加name属性 -->
	   <!-- :data额外参数 -->
	   <!-- //baseURL:"http://127.0.0.1:3007",baseURL:"http://106.54.229.149:9001",https://zx-cargo.com:9001 -->
	   <el-upload
	   :data={id:userid}
	     accept=".JPG, .PNG, .JPEG,.jpg, .png, .jpeg"
	     :limit="1"
		 :file-list="fileList"
	     list-type="picture-card"
	     action="https://zx-cargo.com:9001/my/update/wxcodecard/"
	     :on-preview="handlePictureCardPreview"
	     :on-remove="handleRemove"
	     :on-success="handleSuccess"
	     :headers="headers"
	      name="wx_code"
	     >
	     <i class="el-icon-plus"></i>
	   </el-upload>
	   <el-dialog :visible.sync="dialogVisible">
	     <img width="100%" :src="dialogImageUrl" alt="">
	   </el-dialog>
	   </el-form-item>
	   </div>
	   
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer" >
		  <!-- 编辑 -->
	    <el-button @click="editDialogVisible = false"  v-if="this.zcsh ==2">取 消</el-button>
	    <el-button type="primary" @click="editUserInfo" v-if="this.zcsh ==2">确 定</el-button>
		<!-- 审核 -->
		<el-button type="danger"  @click="editUnShUserInfo" v-if="this.zcsh !=2">审核不通过</el-button>
		<el-button type="success" @click="editShUserInfo" v-if="this.zcsh !=2">审核通过</el-button>
	  </span>
	</el-dialog>
  <!-- 分配视图对话框 -->
  <el-dialog
  :close-on-click-modal="false"
  :lock-scroll="false"
    title="分配视图"
    :visible.sync="setViewDialogVisible"
    width="50%"
    @close="setViewDialogClosed"
    >
    <el-alert
        title="优先级:全局视图>其它视图,所以选择一项视图即可!"
        type="warning"
        show-icon
    		  :closable="false"
    		  style="margin-bottom: 15px;"
    		  >
      </el-alert>
   <div style="padding: 5px;" class="abow_dialog">
  	 <p>分配视图:
  	   <el-select v-model="value1" multiple placeholder="请选择" @change="jgTreeChange">
  	     <el-option
  	       v-for="item in options"
  	       :key="item.value"
  	       :label="item.label"
  	       :value="item.value">
  	     </el-option>
  	   </el-select>
  	   </p>

   </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="setViewDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveViewInfo">确 定</el-button>
    </span>
  </el-dialog>
<!-- 查看审核资料信息对话框 -->
	<el-dialog
	:close-on-click-modal="false"
	:lock-scroll="false"
	  title="查看用户修改资料信息"
	  :visible.sync="setShowZlDialogVisible"
	  width="80%"
	  @close="setShowZlDialogClosed"
	  >
	  <div style="display: flex;flex-direction: column;">
		  <h1 style="font-weight: bold;font-size: 18px;">当前资料信息</h1>
		  <span style="padding: 10px 0 10px 0;">公司:{{zlData.company}}</span>
		  <span style="padding:10px 0 10px 0;">经营地址:{{zlData.businessaddress}}</span>
		  <span style="padding:10px 0 10px 0;">进出口国家:{{zlData.iaecountries}}</span>
		  <el-divider></el-divider>
		  <h1 style="font-weight: bold;font-size: 18px;">修改资料信息</h1>
		  <span style="padding: 10px 0 10px 0;">公司:{{zlData.updata_company}}</span>
		  <span style="padding:10px 0 10px 0;">经营地址:{{zlData.updata_businessaddress}}</span>
		  <span style="padding:10px 0 10px 0;">进出口国家:{{zlData.updata_iaecountries}}</span>
	  </div>
	  <span slot="footer" class="dialog-footer">
		 <el-button type="primary" @click="saveShowZlInfo" :disabled="this.zlData.audit_zl != 1">审核通过</el-button>
	    <el-button type="danger" @click="unSaveShowZlInfo" :disabled="this.zlData.audit_zl != 1">审核不通过</el-button>
	  
	  </span>
	</el-dialog>






 <!-- 离职交接对话框 -->
  <el-dialog
  :close-on-click-modal="false"
  :lock-scroll="false"
    title="离职交接"
    :visible.sync="handOverDialogVisible"
    width="50%"
    @close="handOverDialogClosed"
    >
<!--    <el-alert
        title="优先级:全局视图>其它视图,所以选择一项视图即可!"
        type="warning"
        show-icon
    		  :closable="false"
    		  style="margin-bottom: 15px;"
    		  >
      </el-alert> -->
   <div style="padding: 5px;font-size: 16px;" class="abow_dialog">
	   
	   <p style="padding: 10px 5px;">当前用户名:  {{handOverData.username}}</p>
	   <p style="padding: 10px 5px;">当前角色:  {{handOverData.rolename}}</p>
	   <p style="padding: 10px 5px;">当前公司:  {{handOverData.company}}</p>
	   
	   
	   
  	 <p>交接人员:
  	   <el-select v-model="handOverId" placeholder="请选择" >
  	    <el-option
  	      v-for="item in handOverlist"
  	      :key="item.id"
  	      :label="item.username"
  	      :value="item.id">
		   <span style="float: left">{{ item.username }}</span>
		   <span style="float: right; color: #8492a6; font-size: 13px">{{ item.rolename }}</span>
		  
		  
  	    </el-option>
  	   </el-select>
  	   </p>

   </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handOverDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handOverInfo">确 定</el-button>
    </span>
  </el-dialog>








		</div>
</template>

<script>
	import { mapGetters } from 'Vuex'
	export default{
		data(){
			// 验证手机号的规则
			var checkMobile = (rule, value, cb) => {
			  // 验证手机号的正则表达式
			  const regMobile = /^1[3456789]\d{9}$/
			
			  if (regMobile.test(value)) {
			    return cb()
			  }
			
			  cb(new Error('请输入合法的手机号'))
			}
			return{
				
				//获取用户列表的参数对象
				queryInfo:{
					query:'',
					audityh:'',
					xgzlaudityh:'',
					levelyh:'',
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:20
				},
				//延时器，防抖，防止用户频繁请求
				timer:null,
				userlist:[],
				total:0,
				dshs:0,
				wtgshs:0,
				dshzczl:0,
				//控制添加用户对话框的显示与隐藏
				addDialogVisible:false,
				//控制修改用户对话框的显示与隐藏
				editDialogVisible:false,
				//添加用户的表单数据
				roleList:[],
				addForm:{
				    email:'',
					password:'',
					username:'',
					phone:'',
					businessaddress:'',
					company:'',
					//iaecountries:'',
					sales:'',
					customer:'',
					role:'',
					customer_rating:'',
					landline:'',
					qq:''
				},
                //添加表单的验证规则对象
				addFormRules:{
					email: [
					{ required: true, message: '请输入用户邮箱', trigger: 'blur' },
					{ type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
					  ],
					username:[
						{required:true,message:'请输入用户名',trigger:'blur'},
						{min:1,max:15,message:'用户名的长度在1~15字符之间',trigger:'blur'}
					],
					password:[
						{required:true,message:'请输入密码',trigger:'blur'},
						{min:6,max:15,message:'密码的长度在6~15字符之间',trigger:'blur'}
					],
					phone:[
						{required:true,message:'请输入用户手机号码',trigger:'blur'},
						{validator:checkMobile,trigger:'blur'}
					],
					businessaddress: [
					  {required:true,message: '请输入经营地址', trigger: 'blur' },
					  { min:1,max:50, message: '经营地址必须是1-50位的字符串', trigger: 'blur' }
					],
					company: [
					  {required:true, message: '请输入所属公司', trigger: 'blur' },
					  {  min:1,max:20, message: '所属公司必须是1-20位的字符串', trigger: 'blur' }
					],
					// iaecountries:[
					// 	{required:true,message:'请输入进出口国家',trigger:'blur'},
					// 	 { min:1,max:50, message:'进出口国家必须是1-50位的字符串', trigger: 'blur' }
					// ],
					sales:[
					            { required: true, message: '请选择销售', trigger: 'change' }
					          ],
					customer:[
					            { required: true, message: '请选择客服', trigger: 'change' }
					          ],
				    role:[
				                { required: true, message: '请选择角色', trigger: 'change' }
				              ],
			        customer_rating:[
						 { required: true, message: '请选择等级', trigger: 'change' }
					]
				},
				//查询到的用户信息对象
				editForm:{},
				salesList:[],
				customerList:[],
				//修改表单的验证规则对象
				editFormRules:{
				phone:[
					{required:true,message:'请输入用户手机号码',trigger:'blur'},
					{validator:checkMobile,trigger:'blur'}
				],
				businessaddress: [
				  {required:true,message: '请输入经营地址', trigger: 'blur' },
				  { min:1,max:50, message: '经营地址必须是1-50位的字符串', trigger: 'blur' }
				],
				company: [
				  {required:true, message: '请输入所属公司', trigger: 'blur' },
				  { min:1,max:20, message: '所属公司必须是1-20位的字符串', trigger: 'blur' }
				],
				// iaecountries:[
				// 	{required:true,message:'请输入进出口国家',trigger:'blur'},
				// 	 { min:1,max:50, message:'进出口国家必须是1-50位的字符串', trigger: 'blur' }
				// ],
				sales_id:[
				            { required: true, message: '请选择销售', trigger: 'change' }
				          ],
				customer_id:[
				            { required: true, message: '请选择客服', trigger: 'change' }
				          ],
				rid:[
				            { required: true, message: '请选择角色', trigger: 'change' }
				          ],
				customer_rating:[
				            { required: true, message: '请选择等级', trigger: 'change' }
				          ]
				},
				//控制分配角色对话框的显示与隐藏
				setRoleDialogVisible:false,
				//需要被分配角色的用户信息
				userInfoS:{},
				//所有角色的数据列表
				roleslist:[],
				//已选中的角色Id值数组
				selectedRoleId:'',
				//--------------分配等级---------------
				selectedLevelId:'',
				setLevelDialogVisible:false,
				levelInfo:{},
				levelList:[
					{
						value:1,
						label:'T0等级'
					},
					{
						value:2,
						label:'T1等级'
					},
					{
						value:3,
						label:'T2等级'
					}
				],
			  //----------------------------------------
        //视图
        setViewDialogVisible:false,
          options: [
        					{
        					  value: 1,
        					  label: '全局视图'
        					},{
        					  value: 2,
        					  label: '对应相关客户视图'
        					},
        					  ],
                value1: [],
        		viewId:'',
				//tabs栏
				activeName:'first',
				//查看审核资料
				setShowZlDialogVisible:false,
				zlData:{},
				
				//****************************************************
				zcsh:'',
				
				//上传图片
				 dialogImageUrl: '',
				 dialogVisible: false,
				fileList:[],
				userid:'',
				//******************离职交接*********************** 
				handOverDialogVisible:false,
				handOverData:{},
				handOverlist:[],
				handOverId:''
			}
		},
		computed:{
				...mapGetters(['menusList']),
		//判断隐藏操作栏	
		judgmentmenusList(){
		let arr1 = [72,73,75,86,90,96]
		let arr2 = 	this.menusList.map((obj) => obj.pid)
		//判断
		for (let i=0;i<arr2.length;i++){
			if(arr1.includes(arr2[i])){
				return true
			}
		}
		},
			
			//获取token
			headers(){	
				let qqt = window.sessionStorage.getItem('token')
				return{
				//身份认证token
				Authorization:qqt,
				//请求头
				}
				
			},
		},
		created(){
		 //  console.log(this.judgmentmenusList)
			this.getUserList()
				
		},
		methods:{
			
			//上传图片
			 handleRemove(file, fileList) {
			        console.log(file, fileList);
			      },
			      handlePictureCardPreview(file) {
			        this.dialogImageUrl = file.url;
			        this.dialogVisible = true;
			      },
			handleSuccess(response,file,fileList){
				this.$store.dispatch('getUserInfoActions')
				console.log(response,file,fileList)
			},
			
			
			
			
		
			changeValue(e) {
			this.queryInfo.pagenum = 1
			clearTimeout(this.timer)
			        this.timer = setTimeout(()=>{
			        		this.queryInfo.query = e
			        		this.getUserList()
			
			        	},500)
			       },
				   
			handleClick(tab, event){
				//console.log(this.activeName)
				if(this.activeName == 'first'){
					this.queryInfo.xgzlaudityh = ''
					this.queryInfo.audityh = ''
					this.queryInfo.levelyh = ''
					this.queryInfo.pagenum = 1
					this.getUserList()
				}else if (this.activeName == 'second'){
					this.queryInfo.xgzlaudityh = ''
					this.queryInfo.levelyh = ''
					this.queryInfo.audityh = 1
					this.queryInfo.pagenum = 1
					this.getUserList()
				}else if (this.activeName == 'third'){
					this.queryInfo.xgzlaudityh = ''
					this.queryInfo.levelyh = ''
					this.queryInfo.audityh = 3
					this.queryInfo.pagenum = 1
					this.getUserList()
				}
				else if (this.activeName == 't0'){
					this.queryInfo.xgzlaudityh = ''
					this.queryInfo.audityh = ''
					this.queryInfo.levelyh = 1
					this.queryInfo.pagenum = 1
					this.getUserList()
				}
				else if (this.activeName == 't1'){
					this.queryInfo.xgzlaudityh = ''
					this.queryInfo.audityh = ''
					this.queryInfo.levelyh = 2
					this.queryInfo.pagenum = 1
					this.getUserList()
				}
				else if (this.activeName == 't2'){
					this.queryInfo.xgzlaudityh = ''
					this.queryInfo.audityh = ''
					this.queryInfo.levelyh = 3
					this.queryInfo.pagenum = 1
					this.getUserList()
				 }
				else if (this.activeName == 'tnone'){
					this.queryInfo.xgzlaudityh = ''
					this.queryInfo.audityh = ''
					this.queryInfo.levelyh = 0
					this.queryInfo.pagenum = 1
					this.getUserList()
				}else if (this.activeName == 'xgzl'){
					this.queryInfo.audityh = ''
					this.queryInfo.levelyh = ''
					this.queryInfo.xgzlaudityh = 1
					this.queryInfo.pagenum = 1
					this.getUserList()
				 }
				
			},	   
				   
				   
			async getUserList(){
				const {data:res} = await this.$http.getuserList({params:this.queryInfo})
				if (res.status !==0){
	             return this.$message.error('获取用户列表失败!')
				}
				this.userlist = res.data
				this.total = res.total
				this.dshs = res.dshs
				this.wtgshs = res.wtgshs
				this.dshzczl = res.dshzczl
				console.log(this.userlist)
			},
			//监听pagesize改变的事件
			handleSizeChange(newSize){
				console.log(newSize)
				this.queryInfo.pagesize = newSize
				this.getUserList()
			},
			//监听页面值改变的事件
			handleCurrentChange(newPage){
				console.log(newPage)
				this.queryInfo.pagenum = newPage
				this.getUserList()
			},
			// //监听 switch 开关状态的改变
			async userStateChanged(userinfo){
				const {data:res} = await this.$http.updateState({data:{statesw:userinfo.statesw,id:userinfo.id}})
				if (res.status !==0){
					return this.$message.error('更新用户状态失败!')
					  	userinfo.statesw = !userinfo.statesw
				}
				this.$message.success('更新用户状态成功!')
			},
			adduserData(){
				this.getMySalesList()
				this.getMyRolesList()
				this.getMyCustomerList()
				this.addDialogVisible = true
			},
			//点击按钮，添加新用户
			addUser(){
				const addDataForm ={
					email:this.addForm.email,
					password:this.addForm.password,
					username:this.addForm.username,
					phone:this.addForm.phone,
					businessaddress:this.addForm.businessaddress,
					company:this.addForm.company,
					//iaecountries:this.addForm.iaecountries,
					sales_id:this.addForm.sales,
					customer_id:this.addForm.customer,
					rid:this.addForm.role,
					customer_rating:this.addForm.customer_rating,
					landline:this.addForm.landline,
					qq:this.addForm.qq
				}
				this.$refs.addFormRef.validate(async valid =>{
					if (valid){ //如果表单验证合格
						const { data: res } = await this.$http.addUserData(addDataForm)
					if (res.status == 2){
					return this.$message.error('该邮箱账户已被注册,请更换邮箱账户！')
					} else if(res.status == 3){
					return this.$message.error('该手机号码已被注册,请更换手机号码！')	
					}else if(res.status == 1){
					return this.$message.error(res.message.includes('users.username_UNIQUE')== true ? `该用户名已被注册,请更换用户名！` : res.message)	
					} else if(res.status == 0){
							this.$message.success('添加用户成功')
							this.addDialogVisible = false
							this.getUserList()
					}
					
						
					}else{//表单验证不合格，阻止默认行为（因为按钮有默认提交行为）
						return false
					}

				})
			},
			//监听添加用户对话框的关闭
			addDialogClosed(){
				this.$refs.addFormRef.resetFields()
				this.handleRemove()
			},
			//获取销售信息
			async getMySalesList(){
				const { data: res } = await this.$http.getMySales()
				if (res.status !== 0){
				return this.$message.error('获取信息失败！')
				}
				this.salesList = res.data
			},
			//获取客服信息
			async getMyCustomerList(){
				const { data: res } = await this.$http.getMyCustomer()
				if (res.status !== 0){
				return this.$message.error('获取信息失败！')
				}
				this.customerList = res.data
			},
			//获取角色信息
			async getMyRolesList(){
				const { data: res } = await this.$http.getrolesList()
				if (res.status !== 0){
				return this.$message.error('获取信息失败！')
				}
				//编辑用户所选全部角色
				this.roleslist = res.data.filter(item =>item.type !=1)
				//审核用户选直客，同行客户，海外代理角色
				
			},
			
			//展示编辑用户的对话框
			async showEditDialog(data){
				
				this.userid = data.id
				this.zcsh = data.audit
				const id = data.id
				const {data:res} = await this.$http.byIduser(id)
				if (res.status !==0){
					return this.$message.error('查询用户信息失败!')
				}
				this.getMySalesList()
				this.getMyCustomerList()
				this.getMyRolesList()
				this.editForm = res.data
				 this.editForm.sales_id = Number(res.data.sales_id) == 0 ? '' : Number(res.data.sales_id)
			    this.editForm.customer_id = Number(res.data.customer_id) == 0 ? '' : Number(res.data.customer_id)
			    this.editForm.rid = Number(res.data.rid) == 0 ? '' : Number(res.data.rid)
				this.editForm.customer_rating =  Number(res.data.customer_rating) == 0 ? '' : Number(res.data.customer_rating)  
				 
				 //回显图片
				 if(res.data.wx_code){
					this.fileList.push({
					            'url':res.data.wx_code
					          }) 
				 }
				this.editDialogVisible = true
			},
		//修改用户信息并提交
		editUserInfo(){
			const editDataForm ={
				id:this.editForm.id,
				username:this.editForm.username,
				phone:this.editForm.phone,
				businessaddress:this.editForm.businessaddress,
				company:this.editForm.company,
				//iaecountries:this.editForm.iaecountries,
				sales_id:this.editForm.sales_id,
				customer_id:this.editForm.customer_id,
				rid:this.editForm.rid,
				customer_rating:this.editForm.customer_rating,
				audit:2,
				landline:this.editForm.landline,
				qq:this.editForm.qq
			}
			this.$refs.editFormRef.validate(async valid =>{
				if (valid){
					const confirmResult = await this.$confirm('确认修改该用户信息, 是否继续?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning',
					}).catch(err => err)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消')
					}
					const {data:res} = await this.$http.editUser({data:editDataForm})
						if (res.status ==2){
							return this.$message.error('该手机号码已被注册,请更换手机号码！')
						}else if(res.status == 1){
					return this.$message.error(res.message.includes('users.username_UNIQUE')== true ? `该用户名已被注册,请更换用户名！` : res.message)	
					}else if (res.status ==0){
						this.$message.success('修改信息成功!')
						//隐藏修改用户的对话框
						this.editDialogVisible = false
						this.getUserList()	
						this.$store.dispatch('getUserInfoActions')
						}
				

				}else{
					return false
				}

			})
		},
					//监听修改用户对话框的关闭
		editDialogClosed(){
			this.$refs.editFormRef.resetFields()
			this.fileList = []
		},
//审核注册通过
		editShUserInfo(){
			const editDataForm ={
				id:this.editForm.id,
				username:this.editForm.username,
				phone:this.editForm.phone,
				businessaddress:this.editForm.businessaddress,
				company:this.editForm.company,
				//iaecountries:this.editForm.iaecountries,
				sales_id:this.editForm.sales_id,
				customer_id:this.editForm.customer_id,
				rid:this.editForm.rid,
				customer_rating:this.editForm.customer_rating,
				audit:2,
				landline:this.editForm.landline,
				qq:this.editForm.qq
			}
			//console.log(editDataForm)
			this.$refs.editFormRef.validate(async valid =>{
				if (valid){
					const {data:res} = await this.$http.editUser({data:editDataForm})
						if (res.status ==2){
							return this.$message.error('该手机号码已被注册,请更换手机号码！')
						}else if(res.status == 1){
					return this.$message.error(res.message.includes('users.username_UNIQUE')== true ? `该用户名已被注册,请更换用户名！` : res.message)	
					}else if (res.status ==0){
						this.$message.success('审核通过成功!')
						//隐藏修改用户的对话框
						this.editDialogVisible = false
						//this.getUserList()
							window.location.reload()
						this.$store.dispatch('getUserInfoActions')
						}
				
			
				}else{
					return false
				}
			
			})
		},
//审核注册不通过
		editUnShUserInfo(){
			const editDataForm ={
				id:this.editForm.id,
				username:this.editForm.username,
				phone:this.editForm.phone,
				businessaddress:this.editForm.businessaddress,
				company:this.editForm.company,
				//iaecountries:this.editForm.iaecountries,
				sales_id:this.editForm.sales_id,
				customer_id:this.editForm.customer_id,
				rid:this.editForm.rid,
				customer_rating:this.editForm.customer_rating,
				audit:3,
				landline:this.editForm.landline,
				qq:this.editForm.qq
			}
			
			this.$refs.editFormRef.validate(async valid =>{
				if (valid){
					const {data:res} = await this.$http.editUser({data:editDataForm})
						if (res.status ==2){
							return this.$message.error('该手机号码已被注册,请更换手机号码！')
						}else if(res.status == 1){
					return this.$message.error(res.message.includes('users.username_UNIQUE')== true ? `该用户名已被注册,请更换用户名！` : res.message)	
					}else if (res.status ==0){
						this.$message.success('审核不通过操作成功!')
						//隐藏修改用户的对话框
						this.editDialogVisible = false
						this.getUserList()	
						this.$store.dispatch('getUserInfoActions')
						}
				
			
				}else{
					return false
				}
			
			})
		},
		
		
		
		
		//根据Id删除对应的用户信息
		async removeUserById(id){
			//弹框询问用户是否删除数据
			        const confirmResult = await this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning',
					   lockScroll:false
			        }).catch(err => err)
					//如果用户确认删除，则返回值为字符串 confirm
					console.log(confirmResult)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					const {data:res} = await this.$http.delUser(id)
					if (res.status ==2){
						return this.$message.error('该用户还存在客户资源，不得删除!')
					}
					this.$message.success('删除用户成功!')
					this.getUserList()
		},

    //--------------------------------视图
    //分配视图
    setView(index,view){
    	console.log(view.id,view.view_st)
    	this.viewId = view.id
    	//split字符串变成数组,数组如果有引号，需要纯数字则map(Number)
    	this.value1 =view.view_st == null ? []:view.view_st.split(",").map(Number)
    	this.setViewDialogVisible = true
    },
    //监听视图的选值
    jgTreeChange(val){
    	console.log(val)
    },
    //分配视图
    async saveViewInfo(){
    	//去除数组选值莫名多出来的0
    	let arry = this.value1.filter((el) => {
    	    return el !== 0
    	})
    	let idStr = arry.join(",")
    	console.log(idStr)
    	 const {data:res} = await this.$http.saveView(
    	 {data:{
    	 	id:this.viewId,
    	 	view_st:idStr
    	 }}
    	 )
    	 if (res.status !==0){
    	  return this.$message.error('分配视图失败！')
    	 }
    	 this.$message.success('分配视图成功!')
    	 this.setViewDialogVisible = false
    	 this.getUserList()

    },
    setViewDialogClosed(){
    	this.value1=''
    },

 //   async Approved(id){
	// 	const {data:res} = await this.$http.AuditUserState({data:{
	// 		audit:2,
	// 		id:id
	// 	}})
	// 	if (res.status !==0){
	// 	 return this.$message.error('审核通过操作失败!')
	// 	}
	// 	this.$refs.popover.showPopper = false;
	// 	this.getUserList()
	// },
 // async	ApprovedError(id){
	// 	const {data:res} = await this.$http.AuditUserState({data:{
	// 		audit:3,
	// 		id:id
	// 	}})
	// 	if (res.status !==0){
	// 	 return this.$message.error('审核不通过操作失败!')
	// 	}
	// 	this.$refs.popover.showPopper = false;
	// 	this.getUserList()
	// 	//location.reload()
	// },
//审核资料卡片查看
showEditShzlDialog(data){
	this.zlData = data
	this.setShowZlDialogVisible = true
},
//审核资料通过
async saveShowZlInfo(){
	const {data:res} = await this.$http.AuditShZlUser({data:{
		audit_zl:2,
		id:this.zlData.id
	}})
	if (res.status !==0){
	 return this.$message.error('审核通过操作失败!')
	}
	this.$message.success('操作成功!')
	this.setShowZlDialogVisible = false
	this.getUserList()
	this.$store.dispatch('getUserInfoActions')
	
},
//审核资料不通过
async unSaveShowZlInfo(){
	const {data:res} = await this.$http.AuditShZlUser({data:{
		audit_zl:3,
		id:this.zlData.id
	}})
	if (res.status !==0){
	 return this.$message.error('审核不通过操作失败!')
	}
	 this.$message.success('操作成功!')
	this.setShowZlDialogVisible = false
	this.getUserList()
},


ssgsChange(e){
	
	
	
},
setShowZlDialogClosed(){
	this.zlData = {}
},
async handOverClick(index,item){
	this.handOverData = item
	const {data:res} = await this.$http.getHandOverList(item.id)
	this.handOverlist = res.data
	this.handOverDialogVisible = true
},
async handOverInfo(){
	//console.log(this.handOverData.id,this.handOverId)
	const {data:res} = await this.$http.confirmHandOver({data:{
		userId:this.handOverData.id,
		handOverId:this.handOverId
	}})
	console.log(res)
	if (res.status ==1){
	 return this.$message.error('当前用户，无客户资源转移，操作失败!')
	}
	this.$message.success('交接成功!')
	this.handOverDialogVisible = false
	this.getUserList()
},
handOverDialogClosed(){
	this.handOverData ={}
	this.handOverlist=[]
	this.handOverId=''
},


		}
	}
</script>
<style lang="less" scoped>
.abow_dialog{
	height: 350px;
}
 @media screen and (min-width: 1280px) {
	.wrapperddiv{
		height: 100vh;
		width: 100%;
		display:inline-block;
	} 
 }

 //手机端
 @media screen and (max-width: 1280px) {
	.wrapperddiv{
		height: 100%;
		width: 100%;
		display:inline-block;
	} 
 }
</style>
